import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Alert, Button, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';
import CommonPagination from '../components/CommonPagination';

import CommonToast from '../components/CommonToast';
import CommonConfirmModal from '../components/CommonConfirmModal';
import CommonAlert from '../components/CommonAlert';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonButton from '../components/CommonButton';
import CommonDropdown from '../components/CommonDropdown';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonCheckbox from '../components/CommonCheckbox';

import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonPreviewFileModal from '../components/CommonPreviewFileModal';

import CommonTokenExpired from '../components/CommonTokenExpired';

import * as constants from '../../config/constants/AppConstants';

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import InlineCertificationTrainingListEB04 from '../inline/InlineCertificationTrainingListEB04';

import { GlobalStates } from '../states/GlobalStates';

/** individual page state */
import { PageDataState } from '../states/EB04DataCertificationState';

/** requester handle */
import requester from "../../library/Requester"; 

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

/** define end point */
const TABLE = `certification_eb_04`;
const URL = `api/master/${TABLE}`;

const PARENT = 'training_details_enterprise_eb_03_id';

class InlineCertificationEB04 extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);

        this.inlineInputRowRef = React.createRef();
    }    

    initialize = async () => {
        let {refKey, refPage, fkId, fkVal} = this.props;

        await Actions.parametersInline(this.updateState, PARENT, {id: fkId, value: fkVal, key: refKey, page: refPage});

        if (fkId && fkVal) {
            await this.loadMasterbase();
            await this.setDefaultInputs();
        }
    }      

    loadMasterbase = async () => {  
        let { Inputs } = this.state;
        let sets = [
            { key: "training_details_enterprise_eb_03_lists", filter: [{ field: 'id', value: Inputs.training_details_enterprise_eb_03_id.value }]}, 
            { key: "certification_eb_04", filter: [{ field: 'training_details_enterprise_eb_03_id', value: Inputs.training_details_enterprise_eb_03_id.value }]},                        
        ]; 
        
        await Actions.loadMasterbase(this.updateState, sets);
    }  

    setDefaultInputs = async () => {
        await Actions.setDefaultInputs(this.updateState, PARENT, async () => {

            let { Inputs, Masterbase } = this.state;
            
            const eb04 = (Array.isArray(Masterbase?.certification_eb_04) && Masterbase.certification_eb_04.length > 0)
            ? Masterbase.certification_eb_04[0]
            : null;    
            
            if(!util.isEmpty(eb04?.id)){ 
                await this.fetchForEdit({id: eb04?.id});
            }
        });
    } 

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'Inline', mode: 'update', bool: true},
            this.state.Inputs
        );        
    }    

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable,
            null,
            this.state.Inputs
        );
    }   
    
    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, null);
        Actions.handleDiscardInputs(this.updateState, 'Inputs');
        this.setDefaultInputs();
    }
    
    componentDidMount = async () => { 
        await this.initialize();
    };

    componentDidUpdate = async (prevProps) => {
        if (prevProps.fkVal !== this.props.fkVal && !util.isEmpty(this.props.fkVal)) {
            await this.initialize();
        }        
    }    

    render = () => {
        
        let { Action, DataTable, Inputs, Masterbase, InputGroup, Deletes, Operation, Parameters, Token } = this.state;

        let { onDrillUpInline } = this.props;

        let { show, mode } = Action.Inline;

        let { Submit } = Operation;

        let isLoading = Action.Loading.submit;        

        const isFk = Parameters[PARENT]?.parameters?.element?.find(item => item.id === PARENT)?.value ?? null;

        const profile = (Array.isArray(Masterbase?.training_details_enterprise_eb_03_lists) && Masterbase.training_details_enterprise_eb_03_lists.length > 0)
            ? Masterbase.training_details_enterprise_eb_03_lists[0]
            : null;        

        return (
            <Container fluid className="data-table-container" style={{border: '1px solid #EEE', borderRadius: '8px', padding: '4px'}}>

                <CommonTokenExpired Token={Token} />

                <CommonPreviewFileModal
                    Action={Action}
                    onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                />

                <CommonToast 
                    toast={Action.Toast} 
                    onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                /> 

                <CommonConfirmModal 
                    Action={Action}
                    Deletes={Deletes}

                    onCallback={async (e) => { 
                        let result = await Actions.handleControlModal(this.updateState, e);
                        if(result.action){
                            if (result.section === 'Delete'){ await this.deleteData(); }
                        }
                    }}
                />

                {profile?.enterprise_name && (
                    <>

                        <Row className="mt-3">
                            <Col md={12}>
                                <div className="d-flex justify-content-between align-items-center mb-2 ms-2 me-2">
                                    <h5 className="mb-0 d-flex align-items-center gap-2">
                                        <Badge bg="primary" pill>{`สถานประกอบการที่เข้าร่วมอบรม รุ่นที่ : ${profile?.model_no}`}</Badge>
                                        <Badge bg="info" pill>{`สถานประกอบการ : ${profile?.enterprise_name}`}</Badge>
                                    </h5>

                                    <CommonButton 
                                        task="back" 
                                        rounded={true}
                                        disabled={false}
                                        callback={(e) => onDrillUpInline({ key: 'certification_eb_04' })}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Col md={12} className="d-flex align-items-center justify-content-center text-center">
                                <h6>แบบรายงานผลการจัดอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</h6>
                            </Col>
                        </Row>                      

                        {!util.isEmpty(Inputs.id.value) && (    
                            <Row>
                                <Col md={{ span: 12, offset: 0 }} className="mb-3">                                                                        
                                    <InlineCertificationTrainingListEB04
                                        fkId="certification_eb_04_id"
                                        fkVal={Inputs.id.value}
                                        fkUserCookie={this.props.fkUserCookie}
                                        onRowCountChange={(count) => this.setState({ childRowCount: count })}
                                    /> 
                                </Col>                                        
                            </Row>                                                       
                        )}                          

                        <Row className="mt-3">
                            <Col md={4} className="mb-3 text-end">{util.formatLabel('', Inputs.paid_trainee_count, '', 'sm')}</Col>   
                            <Col md={1} className="mb-3">
                                <CommonInput
                                    element="Inputs"
                                    input={Inputs.paid_trainee_count}
                                    size="sm"
                                    hr={false}
                                    floatingLabel={false}
                                    callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                />    
                            </Col>  
                            <Col md={2} className="mb-3">
                                <div className="d-flex justify-content-between">
                                    <span className="label-size-sm">คน</span>
                                    <span className="label-size-sm">
                                        เป็นจำนวนเงิน
                                        <i 
                                            className="fa-classic fa-light fa-asterisk fa-fw" 
                                            style={{ fontSize: '0.5rem', verticalAlign: 'text-top' }} 
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </div>
                            </Col>  
                            <Col md={1} className="mb-3">
                                <CommonInput
                                    element="Inputs"
                                    input={Inputs.amount}
                                    size="sm"
                                    hr={false}
                                    floatingLabel={false}
                                    callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                />  
                            </Col>  
                             <Col md={2} className="mb-3"><span className="label-size-sm">บาท</span></Col>                                                
                        </Row>

                        <Row>
                            <Col md={4} className="mb-3 text-end">{util.formatLabel('', Inputs.evidence, '', 'sm')}</Col>   
                            <Col md={8} className="mb-3">
                                <CommonFile
                                    element="Inputs"
                                    input={Inputs.evidence}
                                    size="sm"
                                    hr={false}
                                    floatingLabel={false}
                                    callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 

                                    previewFile={(e) => Actions.handlePreviewFile(this.updateState, e)} 
                                    deleteFile={(field, pk) =>  Actions.deleteFile(this.updateState, URL, field, Inputs.id)} 
                                />   
                            </Col>  
                        </Row>                        

                        <Row>
                            <Col md={4} className="mb-3 text-end">{util.formatLabel('', Inputs.fullname, '', 'sm')}</Col>   
                            <Col md={3} className="mb-3">
                                <CommonInput
                                    element="Inputs"
                                    input={Inputs.fullname}
                                    size="sm"
                                    hr={false}
                                    floatingLabel={false}
                                    callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                />  
                            </Col> 
                        </Row>
                        <Row>
                            <Col md={4} className="mb-3 text-end">{util.formatLabel('', Inputs.position, '', 'sm')}</Col>                              
                            <Col md={3} className="mb-3">
                                <CommonInput
                                    element="Inputs"
                                    input={Inputs.position}
                                    size="sm"
                                    hr={false}
                                    floatingLabel={false}
                                    callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                />  
                            </Col>                                                          
                        </Row>  

                        <Row>
                            <Col md={4} className="mb-3 text-end">{util.formatLabel('', Inputs.form_date, '', 'sm')}</Col>   
                            <Col md={1} className="mb-3">
                                <CustomDatePicker
                                    element="Inputs"
                                    input={Inputs.form_date}
                                    size="sm"
                                    hr={false}
                                    floatingLabel={false}
                                    callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                /> 
                            </Col>  
                        </Row>

                        <Row><Col md="12"><hr className="mt-0 mb-3"></hr></Col></Row>

                        <Row>
                            <Col md="12" className="mb-3">

                                <CommonLoadingBar isLoading={isLoading} />

                                <div className="d-flex justify-content-end mt-2">
                                    <CommonButton 
                                        task={`${mode}`} 
                                        disabled={isLoading ? true : Submit ? false : true}
                                        callback={async (e) => await this.submitData() }
                                    /> 

                                    {!util.isEmpty(Inputs.id.value) && this.state.childRowCount === 0 && (                                        
                                        <CommonButton 
                                            task="delete-no-text" 
                                            inlineClass="ms-1 me-2" 
                                            callback={async (e) => { 
                                                Actions.handleDataTableToggleDelete(this.updateState, {target: {checked : true, value: Inputs.id.value} })
                                                Actions.handleControlModal(this.updateState, {mode: 'confirm-delete', show: true, action: false});
                                            }}
                                        />
                                    )}
                                </div>                            
                            </Col>
                        </Row>
                    </>
                )}
            </Container>
        )
    }
}

export default InlineCertificationEB04;